import React from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import styled from "styled-components";
import { Button } from "@material-ui/core";
import { FileUpload } from "@material-ui/icons";
import UploadSpreadsheetModal from "./UploadSpreadsheetModal";

const InactiveSection = styled.div`
  padding-left: 6px;
  padding-top: 10px;
  padding-bottom: 10px;
  transition: background 0.3s;
  &:hover {
    background: #f4f4f4;
    cursor: pointer;
  }
  position: relative;
  color: ${props => (props.isChildOpen ? "#2B5979;" : "#2196F3;")};
`;
const ActiveSection = styled(InactiveSection)`
  border-left: 4px solid #2b5979;
  color: #2b5979;
`;
const InactiveChildSection = styled.div`
  padding-left: 24px;
  padding-top: 10px;
  padding-bottom: 10px;
  transition: background 0.3s;
  &:hover {
    background: #f4f4f4;
    cursor: pointer;
  }
`;
const ActiveChildSection = styled(InactiveChildSection)`
  border-left: 4px solid #2b5979;
  color: #2b5979;
`;

const SectionWrapper = styled.div`
  font-size: 17px;
`;

const SideNavWrapper = styled.div`
  margin-left: 10px;
  background: #fafafa;
  max-width: 220px;
`;

const SideNavButtonWrapper = styled.div`
  margin-top: 10px;
`;

const Section = ({ title, sectionId, activeSectionId, isChildOpen, onClick }) => {  
  return (
    <>
      <SectionWrapper onClick={() => onClick(sectionId)}>
        {activeSectionId === sectionId && (
          <ActiveSection isChildOpen={isChildOpen}>
            <span>{title}</span>
          </ActiveSection>
        )}
        {activeSectionId !== sectionId && (
          <InactiveSection isChildOpen={isChildOpen}>
            <span>{title}</span>
          </InactiveSection>
        )}
      </SectionWrapper>
    </>
  );
};

const ChildSection = ({ title, sectionId, activeSectionId, onClick }) => {
  return (
    <>
      <SectionWrapper onClick={() => onClick(sectionId)}>
        {activeSectionId === sectionId && (
          <ActiveChildSection>
            <span>{title}</span>
          </ActiveChildSection>
        )}
        {activeSectionId !== sectionId && (
          <InactiveChildSection>
            <span>{title}</span>
          </InactiveChildSection>
        )}
      </SectionWrapper>
    </>
  );
};

class LoanDetailsSideNav extends React.Component {
  constructor(props) {
    super(props);
    this.state = { uploadSpreadsheetModalOpen: false };
  }

  onSectionClick = sectionId => {    
    this.props.selectSection(sectionId);
  };

  renderLoanSectionChildren = (activeSectionId, isQuote) => {
    if (!activeSectionId.includes("loan_section")) return null;
    return (
      <>
        <ChildSection title={isQuote ? `Quote Terms` :`Loan Terms`} sectionId="loan_section_loan_details" activeSectionId={activeSectionId} onClick={this.onSectionClick} />
        <ChildSection title="Amortization Details" sectionId="loan_section_amort_details" activeSectionId={activeSectionId} onClick={this.onSectionClick} />
        <ChildSection title="Additional Advances" sectionId="loan_section_additional_advances" activeSectionId={activeSectionId} onClick={this.onSectionClick} />
        <ChildSection title="Insurance" sectionId="loan_section_insurance" activeSectionId={activeSectionId} onClick={this.onSectionClick} />
        <ChildSection title="Extension Terms" sectionId="loan_section_extension_terms" activeSectionId={activeSectionId} onClick={this.onSectionClick} />
        <ChildSection title="Prepayment Terms" sectionId="loan_section_prepayment_terms" activeSectionId={activeSectionId} onClick={this.onSectionClick} />
        <ChildSection title="Closing Costs" sectionId="loan_section_closing_costs" activeSectionId={activeSectionId} onClick={this.onSectionClick} />
        <ChildSection title="Contact Information" sectionId="loan_section_contact_info" activeSectionId={activeSectionId} onClick={this.onSectionClick} />
      </>
    );
  };

  renderCovenantsSectionChildren = (activeSectionId, isQuote) => {
    if (!activeSectionId.includes("covenants_section")) return null;
    return (
      <>
        <ChildSection title="Financial Reporting" sectionId="covenants_section_financial_reporting" activeSectionId={activeSectionId} onClick={this.onSectionClick} />
        <ChildSection title="Financial Covenants" sectionId="covenants_section_financial_covenants" activeSectionId={activeSectionId} onClick={this.onSectionClick} />
        {!isQuote && <ChildSection title="Definitions" sectionId="covenants_section_definitions" activeSectionId={activeSectionId} onClick={this.onSectionClick} />}
        <ChildSection title="Cash Management" sectionId="covenants_section_cash_management" activeSectionId={activeSectionId} onClick={this.onSectionClick} />
        <ChildSection title="Escrow Accounts" sectionId="covenants_section_escrow_accounts" activeSectionId={activeSectionId} onClick={this.onSectionClick} />
        <ChildSection title="Partial Release" sectionId="covenants_section_partial_release" activeSectionId={activeSectionId} onClick={this.onSectionClick} />
        <ChildSection title="Property Allocations" sectionId="loan_section_property_allocation" activeSectionId={activeSectionId} onClick={this.onSectionClick} />
        <ChildSection title="Leasing" sectionId="covenants_section_leasing" activeSectionId={activeSectionId} onClick={this.onSectionClick} />
      </>
    );
  };

  isLoanChildOpen = activeSectionId => activeSectionId.includes("loan_section");

  isCovenantsChildOpen = activeSectionId => activeSectionId.includes("covenants_section");

  onUploadSpreadsheetModalClose = loadExtraction => {
    this.setState({ uploadSpreadsheetModalOpen: false });
    this.props.onUploadSpreadsheetModalClose(loadExtraction);
  };

  render() {
    const { activeSectionId, authentication, isEditing, quoteConditions} = this.props;    
    
    return (
      <>
        <SideNavWrapper>
          <Section
            title="General Information"
            sectionId="loan_section"
            activeSectionId={activeSectionId}
            isChildOpen={this.isLoanChildOpen(activeSectionId)}
            onClick={this.onSectionClick}
          />

          {!quoteConditions.isPassedLoan && <>
            {this.renderLoanSectionChildren(activeSectionId, quoteConditions.isQuote)}
            <Section
              title="Covenants"
              sectionId="covenants_section"
              activeSectionId={activeSectionId}
              isChildOpen={this.isCovenantsChildOpen(activeSectionId)}
              onClick={this.onSectionClick}            
            />
            {this.renderCovenantsSectionChildren(activeSectionId, quoteConditions.isQuote)}
            <Section title="Recourse" sectionId="recourse_section" activeSectionId={activeSectionId} onClick={this.onSectionClick} />
            <Section title="Hedge Requirements" sectionId="hedge_requirements_section" activeSectionId={activeSectionId} onClick={this.onSectionClick} />
            {!quoteConditions.isQuote && <Section title="Quote History" sectionId="quote_history_section" activeSectionId={activeSectionId} onClick={this.onSectionClick} />}
            {quoteConditions.isQuote && <Section title="Other" sectionId="other_section" activeSectionId={activeSectionId} onClick={this.onSectionClick} />}
            {!quoteConditions.isQuote && authentication.isSystemAdmin && isEditing && (
              <SideNavButtonWrapper>
                <Button variant="outlined" color="primary" onClick={() => this.setState({ uploadSpreadsheetModalOpen: true })}>
                  <FileUpload /> UPLOAD CHANGES
                </Button>
              </SideNavButtonWrapper>
            )}
          </>}
          {quoteConditions.isPassedLoan && <Section title="Passed Quote" sectionId="passed_quote_section" activeSectionId={activeSectionId} onClick={this.onSectionClick} />}
        </SideNavWrapper>
        <UploadSpreadsheetModal isOpen={this.state.uploadSpreadsheetModalOpen} onClose={this.onUploadSpreadsheetModalClose} loanId={this.props.loanId} />
      </>
    );
  }
}

const mapStateToProps = ({ authentication }) => ({
  authentication
});

export default compose(connect(mapStateToProps, {}))(LoanDetailsSideNav);
